module.exports = __webpack_public_path__ + "static/edit-product-custom-image-badge-8cbf2e4f56f293956c7effe8a903a50d.png";